import React, { useState, useEffect } from "react";
import { DataStore } from "@aws-amplify/datastore";
import { Card } from "react-bootstrap";
import { VehicleModelGeneralInfo } from "../models";

function Suggestions({ suggestions, onSuggestionSelect }) {
    return (
        <div className="disappear card mx-auto d-flex flex-column justify-content-between">
            {suggestions.map((suggestion, index) => (
                <div
                    key={index}
                    className="suggestion-item"
                    onClick={() => onSuggestionSelect(suggestion)}
                >
                    {suggestion.Manufacturer} {suggestion.ModelName}
                </div>
            ))}
        </div>
    );
}

export default function Ships() {
    const [ships, setShips] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedShips, setSelectedShips] = useState(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);

    useEffect(() => {
        const searchInput = document.querySelector(".search-input");
        const suggestionsList = document.querySelector(".disappear");

        function handleClickOutside(event) {
            if (searchInput && !searchInput.contains(event.target) && suggestionsList && !suggestionsList.contains(event.target)) {
                setFilteredSuggestions([]);
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchShips();
    }, []);

    async function fetchShips() {
        try {
            const fetchedShips = await DataStore.query(VehicleModelGeneralInfo);
            setShips(fetchedShips);
        } catch (error) {
            console.error("Error fetching ships:", error);
        }
    }

    function filterShips(ship, searchQuery) {
        const words = searchQuery.toLowerCase().split(" ");
        return (
            ship.VehicleType === "SHIP" &&
            ship.Manufacturer &&
            ship.ModelName &&
            words.every(
                (word) =>
                    ship.Manufacturer.toLowerCase().includes(word) ||
                    ship.ModelName.toLowerCase().includes(word)
            )
        );
    }

    function handleInputChange(event) {
        const query = event.target.value;
        setSearchQuery(query);
        const suggestions = ships.filter((ship) => filterShips(ship, query));
        setFilteredSuggestions(suggestions);
    }

    function handleSuggestionSelect(suggestion) {
        setSelectedShips(suggestion);
        setFilteredSuggestions([]); // Clear suggestions
    }

    function toggleSuggestions() {
        if (filteredSuggestions.length > 0) {
            setFilteredSuggestions([]);
        } else {
            const shipsOnly = ships.filter(ship => ship.VehicleType === "SHIP");
            setFilteredSuggestions(shipsOnly);
        }
    }

    return (
        <div style={{ position: "relative" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <input
                    className="search-input card mx-auto d-flex flex-column justify-content-between"
                    type="text"
                    placeholder="Click here to see ships or search ship models..."
                    value={searchQuery}
                    onChange={handleInputChange}
                    onClick={toggleSuggestions}
                    style={{ padding: "10px", marginBottom: "5px" }}
                />

                {filteredSuggestions.length > 0 && (
                    <Suggestions
                        suggestions={filteredSuggestions}
                        onSuggestionSelect={handleSuggestionSelect}
                    />
                )}
            </div>

            {selectedShips && (
                <div className="homepageCarousel">
                    <Card className="card mx-auto d-flex flex-column justify-content-between">
                        <div>
                            <Card.Img
                                variant="top"
                                src={selectedShips.Picture}
                                alt={`Slide Ship`}
                                className="card-image"
                            />
                            <Card.Body className="card-body"
                                style={{ maxHeight: "400px", overflowY: "auto" }}>
                                <Card.Text>Manufacturer: {selectedShips.Manufacturer}</Card.Text>
                                <Card.Text>Model Name: {selectedShips.ModelName}</Card.Text>
                                <Card.Text>Model Year: {selectedShips.ModelYear}</Card.Text>
                                <Card.Text>Body Style: {selectedShips.BodyStyle}</Card.Text>
                                <Card.Text>Engine Type: {selectedShips.EngineType}</Card.Text>
                                <Card.Text>Fuel Type: {selectedShips.FuelType}</Card.Text>
                                <Card.Text>Top Speed: {selectedShips.TopSpeed}</Card.Text>
                                <Card.Text>Dimensions: {selectedShips.Dimensions}</Card.Text>
                                <Card.Text>Weight: {selectedShips.Weight}</Card.Text>
                                <Card.Text>Cargo Space: {selectedShips.CargoSpace}</Card.Text>
                                <Card.Text>Seating Capacity: {selectedShips.SeatingCapacity}</Card.Text>
                                <Card.Text>Country Of Origin: {selectedShips.CountryOfOrigin}</Card.Text>
                                <Card.Text>Price: {selectedShips.Price}</Card.Text>
                                <Card.Text>Warranty: {selectedShips.Warranty}</Card.Text>
                                <Card.Text>Information: {selectedShips.Information}</Card.Text>
                            </Card.Body>



                        </div>
                    </Card>
                </div>
            )}
        </div>
    );
}


